<style lang="scss" scoped>
.nav {
  position: relative;
  padding: 10px 0;
  // left: 0;
  // right: 0;
  // z-index: 999;
}
.logoImg {
  height: 2.625rem;
}
.menuItem {
  font-size: 1rem;
  color: #000000;
  margin-left: 2rem;
  font-weight: 600;
}
.menuItem.active {
  color: #3581ff;
}
.loginGrp {
  margin-left: 3.75rem;
  border: 1px solid #3581ff;
  border-radius: 0.5rem;
  overflow: hidden;
}
.loginGrp div {
  padding: 0.3rem 1.25rem;
}
.loginGrp div:first-child {
  color: #3581ff;
}
.loginGrp div:nth-child(2) {
  background-color: #3581ff;
  color: #ffffff;
}
@media (max-width: 768px) {
  .mobileNav {
    padding: 0 16px;
    position: relative;
  }
  .mNav {
    padding: 10px 0;
    align-items: center;
  }
  .mNav img:first-child {
    height: 32px;
    width: auto;
  }
  .mNav img:last-child {
    height: 18px;
    width: auto;
  }

  .navMain {
    font-size: 1.17rem;
  }
}
</style>

<template>
  <div>
    <div v-if="!isMobile" class="flex justify-between nav mainContent">
      <div class="cursor-pointer flex items-center">
        <img
          src="@/assets/imgs/footer/footerLogo.jpg"
          alt=""
          class="logoImg"
          @click="clickLogo"
        />
        <span style="font-size: 24px; margin-left: 6px; font-weight: bold"
          >易回复</span
        >
      </div>
      <div class="flex items-center">
        <div class="flex items-center">
          <div
            @click="actdNav(nav)"
            ref="nav"
            :class="{
              active: actNav.label === nav.label,
              'menuItem cursor-pointer': true,
            }"
            v-for="nav in navs"
            :key="nav.label"
          >
            {{ nav.label }}
          </div>
          <div
            v-if="userInfo.userId"
            class="menuItem cursor-pointer"
            style="color: #04bafa"
            @click="toIndex"
          >
            控制台
          </div>
          <div class="menuItem cursor-pointer" v-if="userInfo.userId">
            <span style="padding-right: 5px"
              >欢迎您 {{ userInfo.nickname }}</span
            >
          </div>
        </div>
        <div class="loginGrp cursor-pointer flex items-center">
          <div v-if="!userInfo.userId" @click="register">注册</div>
          <div v-if="!userInfo.userId" @click="login">登录</div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="content" v-if="!isMobile">
        <component
          :is="actNav.component"
          @on-free-test="freeTest"
          @toDownload="toDownload"
        ></component>
      </div>
    </div>
    <Footer v-if="!isLogin && !isMobile"></Footer>
    <!-- <sideBar v-if="!isMobile" @on-free-test="freeTest" />
    <LoginDrawer ref="LoginDrawerRef" @on-login-success="loginSuccess" /> -->
  </div>
</template>

<script>
import sideBar from "@/components/sideBar.vue";
import logoSrc from "@/assets/imgs/footer/footerLogo.png";
import NoticeModal from "@/components/NoticeModal";
import LoginDrawer from "@/components/LoginDrawer";
import router from "@/router/index.js";
import Home from "@/components/index/Home";
import price from "@/components/pageComponets/price";
import Doc from "@/components/index/Doc";
import useDoc from "@/components/pageComponets/useDoc";
import download from "@/components/pageComponets/download";
import AffixCustomerService from "@/components/index/AffixCustomerService";
import Footer from "../components/Footer.vue";
import userService from "@/service/user";
import dataService from "@/service/data";
import mNav from "@/assets/imgs/mobile/nav.png";
import cNav from "@/assets/imgs/mobile/cNav.png";
export default {
  name: "Index",
  components: {
    download,
    NoticeModal,
    LoginDrawer,
    Home,
    price,
    Doc,
    AffixCustomerService,
    Footer,
    useDoc,
    sideBar,
  },
  data() {
    let origin = window.location.origin;
    let chromeCheck = origin.includes("www.traneasy.vip");
    let navs = !chromeCheck
      ? [
          {
            label: "主页",
            img: require("@/assets/bg/home.png"),
            component: "Home",
          },
          {
            label: "定价标准",
            img: require("@/assets/bg/price.png"),
            component: "price",
          },
          {
            label: "软件下载",
            img: require("@/assets/bg/price.png"),
            component: "download",
          },
        ]
      : [
          {
            label: "主页",
            img: require("@/assets/bg/home.png"),
            component: "Home",
          },
          {
            label: "定价标准",
            img: require("@/assets/bg/price.png"),
            component: "price",
          },
          {
            label: "软件下载",
            img: require("@/assets/bg/price.png"),
            component: "download",
          },
          {
            label: "使用说明",
            img: require("@/assets/bg/doc.png"),
            component: "useDoc",
          },
          // 由于与home 一致  故暂时屏蔽
          // {
          //   label: "联系我们",
          //   img: require("@/assets/bg/home.png"),
          //   component: "Home",
          // },
        ];
    let actNav = navs[0];
    const isLogin = false;
    const isMobile =
      window.screen.width > 768 || window.screen.width == 768 ? false : true;
    const showPcNav = true;
    const navTop = "4.5rem";
    return {
      mNav,
      cNav,
      isFreeTest: false,
      userInfo: {},
      downloadData: [],
      innerHeight: window.innerHeight,
      mobileNavIsOpen: false,
      navs,
      actNav,
      isLogin,
      showPcNav,
      isMobile,
      navTop,
      logoSrc,
    };
  },
  mounted() {
    let { act } = this.$route.query;
    if (act) {
      for (var i in this.navs) {
        let nav = this.navs[i];
        if (nav.label === act) {
          this.actNav = nav;
          break;
        }
      }
    }
    window.onresize = () => {
      this.innerHeight = window.innerHeight;
    };
    this.init();
  },
  watch: {
    "router.currentRoute.value.path": {
      handler: function () {
        this.showPcNav =
          !this.isMobile && router.currentRoute.value.path !== "/login";
        if (router.currentRoute.value.path === "/") {
          this.navTop = "4.5rem";
        } else {
          this.navTop = "1rem";
        }
        if (router.currentRoute.value.path === "/login") {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    clickLogo() {
      let inviteCode = this.$route.query.inviteCode;
      if (inviteCode) {
        this.$router.push({ path: "/", query: { inviteCode: inviteCode } });
      } else {
        this.$router.push("/");
      }
    },
    async init() {
      let data = await dataService.get("SOFT_REPLAY_DOWNLOAD_CONFIG");
      if (data?.valued) {
        this.downloadData = JSON.parse(data.valued);
      }

      if (!sessionStorage.getItem("sk")) {
        let inviteCode = this.$route.query.inviteCode;
        if (inviteCode) {
          // this.$refs.LoginDrawerRef.open(2);
          this.$router.push({
            path: "/login",
            query: { type: 2, inviteCode: inviteCode },
          });
        }
        return;
      }
      let userInfo = await userService.get();
      if (userInfo) {
        this.userInfo = userInfo;
      }
    },
    toDownload() {
      this.$refs.nav[2].click();
    },
    actdNav(nav) {
      if (nav.component === "useDoc") {
        window.open(
          "https://uag22c4hqd5.feishu.cn/wiki/RsJuwzfW0ijLUokH9Ssc97y9nRg?from=from_copylink",
          "_blank"
        );
      } else {
        this.actNav = nav;
      }
    },
    login() {
      if (this.$route.query.inviteCode) {
        this.$router.push({
          path: "/login",
          query: { type: 1, inviteCode: this.$route.query.inviteCode },
        });
      } else {
        this.$router.push({ path: "/login", query: { type: 1 } });
      }

      // this.$refs.LoginDrawerRef.open(1);
    },
    register() {
      if (this.$route.query.inviteCode) {
        this.$router.push({
          path: "/login",
          query: { type: 2, inviteCode: this.$route.query.inviteCode },
        });
      } else {
        this.$router.push({ path: "/login", query: { type: 2 } });
      }

      // this.$refs.LoginDrawerRef.open(2);
    },
    async loginSuccess() {
      this.userInfo = await userService.get();
      if (this.isFreeTest) {
        this.freeTest();
      }
    },
    toIndex() {
      this.$router.push({ name: "UserCenter" });
    },
    freeTest() {
      this.isFreeTest = true;
      if (!this.userInfo.userId) {
        this.register();
        return;
      }
      if (this.userInfo.memberGroupId === 1) {
        this.$router.push({ name: "UserCenterChangeTranslateTest" });
      } else {
        this.$router.push({ name: "UserCenterRecharge" });
      }
    },
  },
};
</script>

